import { Box, Typography, Button } from "@mui/material";
import React from "react";
import Navbar from "../components/Navbar.jsx";
import CourseCard from "../components/common-components/CourseCard.jsx";
import Footer from "../components/common-components/Footer.jsx";
import Banner from "../components/img/Banner/CreativeWriting.png";
import "../styles/pages-style/Mob-view-Home.css";
import "../styles/pages-style/Home.css";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

function WritingCourse() {
  const testimonialsRef = useRef(null);
  const reachoutRef = useRef(null);
  const navigate = useNavigate();

  const scrollToReachout = () => {
    if (reachoutRef.current) {
      reachoutRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTestimonials = () => {
    if (testimonialsRef.current) {
      testimonialsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const enrollClick = () => {
    navigate("/ContactUs");
  };
  return (
    <Box className="root-container" sx={{ overflowX: "hidden" }}>
      <Navbar
        scrollToTestimonials={scrollToTestimonials}
        onContactClick={scrollToReachout}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          overflowX: "hidden",
        }}
      >
        <Box
          sx={{
            width: { xs: "308px", sm: "100%", md: "1319px" }, // Adjust width for tablets
            height: { xs: "315px", sm: "auto", md: "339px" }, // Dynamic height for tablets
            mt: "14vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            overflow: "hidden", // Prevents image overflow
            "@media (max-width: 1024px) and (min-width: 768px)": {
              overflow: "visible", // Show full image in tablet view
            },
          }}
        >
          <img
            src={Banner}
            className="responsive-banner-writing"
            alt="Creative Writing"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover", // Default cropping behavior
              objectPosition: "center", // Keeps focus on the center
              borderRadius: "8px",
            }}
          />
        </Box>
        <Box className="course-card-container">
          <CourseCard />
        </Box>
        <Box sx={{ height: "6vh" }}></Box>

        <Box className="fifth-section">
          <Box className="fifth-section-text">
            <Typography variant="h6">
              Enroll today and watch your child’s creativity soar!
            </Typography>
          </Box>
          <Button
            variant="contained"
            className="fifth-section-button"
            onClick={() => {
              enrollClick();
              window.scrollTo({ top: 0 });
            }}
          >
            Enroll Now
          </Button>
        </Box>
        <Box className="footer-class" sx={{ width: "100%" }}>
          {" "}
          <Footer />
        </Box>
      </Box>
    </Box>
  );
}

export default WritingCourse;
